module.exports = __webpack_public_path__ + "img/logout.eecf3f3e.svg";